(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    if (!window.CartAPI) return;

    // Hide "Update cart" button — qty changes fire immediately
    var updateBtn = document.querySelector('.cart-page__update');
    if (updateBtn) updateBtn.style.display = 'none';

    var cartTable = document.querySelector('.cart-table');
    if (!cartTable) return;

    cartTable.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;

      var wrapper = input.closest('[data-line-key]');
      if (!wrapper) return;

      var key = wrapper.dataset.lineKey;
      var qty = parseInt(input.value, 10) || 0;

      window.CartAPI.change(key, qty).then(function (cart) {
        var row = input.closest('.cart-table__row');
        if (row) {
          var lineItem = cart.items.find(function (i) {
            return String(i.key) === String(key);
          });
          if (lineItem && window.formatMoney) {
            var linePriceEl = row.querySelector('.cart-item__line-price');
            if (linePriceEl) linePriceEl.textContent = window.formatMoney(lineItem.final_line_price);
          } else if (qty === 0) {
            row.remove();
          }
        }
        // Update subtotal
        var subtotalEl = document.querySelector('.cart-summary__value');
        if (subtotalEl && window.formatMoney) {
          subtotalEl.textContent = window.formatMoney(cart.total_price);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.collapsible-item__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.collapsible-item');
        var isOpen = item.classList.contains('collapsible-item--open');
        item.classList.toggle('collapsible-item--open');
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var sortSelect = document.getElementById('sort-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        window.location.search = '?sort_by=' + this.value;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-countdown-target]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown-target')).getTime();
      if (isNaN(target)) return;

      var days = el.querySelector('[data-cd-days]');
      var hours = el.querySelector('[data-cd-hours]');
      var mins = el.querySelector('[data-cd-mins]');
      var secs = el.querySelector('[data-cd-secs]');
      var timer = el.querySelector('.countdown__timer');
      var expired = el.querySelector('.countdown__expired');

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var now = Date.now();
        var diff = target - now;

        if (diff <= 0) {
          if (timer) timer.style.display = 'none';
          if (expired) expired.style.display = 'block';
          return;
        }

        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);

        if (days) days.textContent = pad(d);
        if (hours) hours.textContent = pad(h);
        if (mins) mins.textContent = pad(m);
        if (secs) secs.textContent = pad(s);

        requestAnimationFrame(function () { setTimeout(tick, 1000); });
      }

      tick();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.address-card__delete').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var msg = btn.getAttribute('data-confirm');
        if (!confirm(msg)) return;
        var id = btn.getAttribute('data-address-id');
        var form = document.createElement('form');
        form.method = 'post';
        form.action = '/account/addresses/' + id;
        var methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'delete';
        form.appendChild(methodInput);
        document.body.appendChild(form);
        form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(function (item) {
      var trigger = item.querySelector('.faq-item__trigger');
      var answer = item.querySelector('.faq-item__answer');
      if (!trigger || !answer) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('faq-item--open');
        // Close all sibling items
        var allItems = item.closest('.faq__list').querySelectorAll('.faq-item');
        allItems.forEach(function (sibling) {
          if (sibling !== item) {
            sibling.classList.remove('faq-item--open');
            sibling.querySelector('.faq-item__trigger').setAttribute('aria-expanded', 'false');
            sibling.querySelector('.faq-item__answer').hidden = true;
          }
        });
        // Toggle current item
        if (isOpen) {
          item.classList.remove('faq-item--open');
          trigger.setAttribute('aria-expanded', 'false');
          answer.hidden = true;
        } else {
          item.classList.add('faq-item--open');
          trigger.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var MOBILE_BP = 768;
    var HOVER_OPEN_DELAY  = 120; // ms before opening on hover
    var HOVER_CLOSE_DELAY = 250; // ms before closing on mouse-leave

    /* ── Backdrop element ── */
    var backdrop = document.createElement('div');
    backdrop.className = 'mega-menu-backdrop';
    document.body.appendChild(backdrop);

    /* ── Helpers ── */
    function isDesktop() { return window.innerWidth >= MOBILE_BP; }

    var DROPDOWN_BTN_SELECTOR = '.site-header__nav-link--dropdown, .site-header__account-btn';

    function openWrap(wrap) {
      closeAllExcept(wrap);
      wrap.setAttribute('aria-expanded', 'true');
      var btn = wrap.querySelector(DROPDOWN_BTN_SELECTOR);
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (wrap.classList.contains('site-header__dropdown-wrap--mega')) {
        backdrop.classList.add('mega-menu-backdrop--visible');
      }
    }

    function closeWrap(wrap) {
      wrap.setAttribute('aria-expanded', 'false');
      var btn = wrap.querySelector(DROPDOWN_BTN_SELECTOR);
      if (btn) btn.setAttribute('aria-expanded', 'false');
      backdrop.classList.remove('mega-menu-backdrop--visible');
    }

    function closeAllExcept(except) {
      document.querySelectorAll('.site-header__dropdown-wrap[aria-expanded="true"]').forEach(function (w) {
        if (w !== except) closeWrap(w);
      });
    }

    function closeAll() { closeAllExcept(null); }

    /* ── Attach listeners to each dropdown wrap ── */
    document.querySelectorAll('.site-header__dropdown-wrap').forEach(function (wrap) {
      var btn = wrap.querySelector(DROPDOWN_BTN_SELECTOR);
      if (!btn) return;

      var openTimer  = null;
      var closeTimer = null;

      function scheduleOpen() {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { openWrap(wrap); }, HOVER_OPEN_DELAY);
      }

      function scheduleClose() {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          if (wrap.getAttribute('aria-expanded') === 'true') closeWrap(wrap);
        }, HOVER_CLOSE_DELAY);
      }

      /* Desktop: hover intent */
      wrap.addEventListener('mouseenter', function () {
        if (isDesktop()) scheduleOpen();
      });
      wrap.addEventListener('mouseleave', function () {
        if (isDesktop()) scheduleClose();
      });

      /* Mobile + desktop: click toggle */
      btn.addEventListener('click', function (e) {
        if (!isDesktop()) {
          /* Mobile accordion */
          e.preventDefault();
          var expanded = wrap.getAttribute('aria-expanded') === 'true';
          if (expanded) { closeWrap(wrap); } else { openWrap(wrap); }
        } else {
          /* Desktop click also works as toggle */
          var expanded = wrap.getAttribute('aria-expanded') === 'true';
          if (expanded) { closeWrap(wrap); } else { openWrap(wrap); }
        }
      });

      /* ── Keyboard navigation ── */
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var expanded = wrap.getAttribute('aria-expanded') === 'true';
          if (expanded) { closeWrap(wrap); } else { openWrap(wrap); }
        }
        if (e.key === 'Escape') {
          closeWrap(wrap);
          btn.focus();
        }
        if (e.key === 'ArrowDown' && isDesktop()) {
          e.preventDefault();
          openWrap(wrap);
          /* Focus first focusable child in panel */
          var panel = wrap.querySelector('.site-header__dropdown, .mega-menu');
          if (panel) {
            var first = panel.querySelector('a, button');
            if (first) first.focus();
          }
        }
      });

      /* Escape key inside panel */
      var panel = wrap.querySelector('.site-header__dropdown, .mega-menu');
      if (panel) {
        panel.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            closeWrap(wrap);
            btn.focus();
          }
        });
      }
    });

    /* ── Close on outside click ── */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.site-header__dropdown-wrap')) {
        closeAll();
      }
    });

    /* ── Backdrop click closes mega menus ── */
    backdrop.addEventListener('click', closeAll);

    /* Mobile hamburger and sticky header handled by theme.js — no duplicate handlers here */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cinematic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('[data-cinematic-zoom]');
    var hero = wrap ? wrap.querySelector('.cinematic-hero--zoom') : null;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var reduced  = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!wrap || !hero) return;
    if (isMobile) return;
    if (reduced) return;

    /* Read configured zoom distance (vh % to complete the effect) */
    var distRaw = getComputedStyle(wrap).getPropertyValue('--zoom-distance').trim();
    var distVH  = parseFloat(distRaw);
    if (!distVH || distVH <= 0) distVH = 100;

    var ticking = false;

    function update() {
      ticking = false;
      var rect = wrap.getBoundingClientRect();
      var winH = window.innerHeight || document.documentElement.clientHeight;
      var totalScroll = winH * (distVH / 100);
      if (totalScroll <= 0) {
        hero.style.setProperty('--zoom-progress', '1');
        return;
      }
      var scrolled = -rect.top;
      var progress = scrolled / totalScroll;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      hero.style.setProperty('--zoom-progress', progress.toFixed(4));
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAll(scope) {
      var root = scope || document;
      var roots = root.querySelectorAll('[data-hero-slider]');
      for (var i = 0; i < roots.length; i++) initSlider(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    // Theme editor: re-init when a section is (re)rendered
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    function initSlider(root) {
      if (root.dataset.hsInit === '1') return;
      root.dataset.hsInit = '1';

      var slides = [].slice.call(root.querySelectorAll('.hs__slide'));
      if (slides.length < 2) return;

      var prevBtn = root.querySelector('[data-hs-prev]');
      var nextBtn = root.querySelector('[data-hs-next]');
      var nums = [].slice.call(root.querySelectorAll('[data-hs-goto]'));
      var bar = root.querySelector('.hs__progress-bar');
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var ppBtn = root.querySelector('[data-hs-playpause]');
      var ppIcon = ppBtn ? ppBtn.querySelector('i') : null;

      var current = 0;
      var startTime = 0;
      var elapsed = 0;
      var rafId = null;
      var hoverPaused = false;
      var offscreen = false;
      var tabHidden = false;
      var userPaused = false;

      function isPaused() { return hoverPaused || offscreen || tabHidden || userPaused; }

      function go(index) {
        index = (index + slides.length) % slides.length;
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        slides[index].classList.add('is-active');
        slides[index].setAttribute('aria-hidden', 'false');
        for (var i = 0; i < nums.length; i++) {
          var on = i === index;
          nums[i].classList.toggle('is-active', on);
          nums[i].setAttribute('aria-current', on ? 'true' : 'false');
        }
        current = index;
        resetProgress();
      }

      function next() { go(current + 1); }
      function prev() { go(current - 1); }

      function resetProgress() {
        elapsed = 0;
        startTime = performance.now();
        if (bar) bar.style.width = '0%';
      }

      function tick(now) {
        if (isPaused()) {
          startTime = now - elapsed;
        } else {
          elapsed = now - startTime;
          var pct = elapsed / speed;
          if (pct > 1) pct = 1;
          if (bar) bar.style.width = (pct * 100).toFixed(2) + '%';
          if (pct >= 1) { next(); }
        }
        rafId = window.requestAnimationFrame(tick);
      }

      if (nextBtn) nextBtn.addEventListener('click', next);
      if (prevBtn) prevBtn.addEventListener('click', prev);
      for (var j = 0; j < nums.length; j++) {
        (function (idx) {
          nums[idx].addEventListener('click', function () { go(idx); });
        })(j);
      }

      // Swipe (horizontal only — ignore vertical scrolls)
      var startX = null;
      var startY = null;
      root.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dx < 0 ? next() : prev(); }
        startX = null;
        startY = null;
      }, { passive: true });

      // Keyboard
      root.setAttribute('tabindex', '-1');
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') next();
        else if (e.key === 'ArrowLeft') prev();
      });

      if (autoplay && !reduced) {
        root.addEventListener('mouseenter', function () { hoverPaused = true; });
        root.addEventListener('mouseleave', function () { hoverPaused = false; });
        root.addEventListener('focusin', function () { hoverPaused = true; });
        root.addEventListener('focusout', function () { hoverPaused = false; });

        // Pause when the browser tab is hidden
        document.addEventListener('visibilitychange', function () { tabHidden = document.hidden; });

        // Pause when scrolled out of view
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            offscreen = !entries[0].isIntersecting;
          }, { threshold: 0.2 });
          io.observe(root);
        }

        // Accessible play/pause toggle
        if (ppBtn) {
          ppBtn.addEventListener('click', function () {
            userPaused = !userPaused;
            ppBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
            ppBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
            if (ppIcon) ppIcon.className = userPaused ? 'fa-solid fa-play' : 'fa-solid fa-pause';
          });
        }

        resetProgress();
        rafId = window.requestAnimationFrame(tick);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var popups = document.querySelectorAll('.newsletter-popup');
    popups.forEach(function (popup) {
      var delay = parseInt(popup.getAttribute('data-popup-delay'), 10) || 5;
      var once = popup.getAttribute('data-popup-once') === 'true';
      var storageKey = 'newsletter-popup-dismissed';
      var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

      if (once) {
        try {
          if (localStorage.getItem(storageKey) === '1') return;
        } catch (e) {}
      }

      function show() {
        popup.style.display = 'flex';
        document.documentElement.classList.add('scroll-locked');

        var focusable = popup.querySelectorAll(focusableSelector);
        if (focusable.length) focusable[0].focus();
      }

      function hide() {
        popup.style.display = 'none';
        document.documentElement.classList.remove('scroll-locked');
        if (once) {
          try { localStorage.setItem(storageKey, '1'); } catch (e) {}
        }
      }

      var useExitIntent = popup.getAttribute('data-exit-intent') === 'true';

      if (useExitIntent) {
        var exitShown = false;

        function onMouseLeave(e) {
          if (exitShown || e.clientY > 5) return;
          exitShown = true;
          document.removeEventListener('mouseleave', onMouseLeave);
          clearTimeout(mobileFallback);
          window.removeEventListener('scroll', onScrollUp, { passive: true });
          show();
        }

        document.addEventListener('mouseleave', onMouseLeave);

        var lastScrollY = window.scrollY;

        function onScrollUp() {
          var currentY = window.scrollY;
          if (lastScrollY - currentY > 60 && currentY > 300 && !exitShown) {
            exitShown = true;
            window.removeEventListener('scroll', onScrollUp, { passive: true });
            document.removeEventListener('mouseleave', onMouseLeave);
            clearTimeout(mobileFallback);
            show();
          }
          lastScrollY = currentY;
        }

        window.addEventListener('scroll', onScrollUp, { passive: true });

        var mobileFallback = setTimeout(function () {
          if (!exitShown) {
            exitShown = true;
            show();
          }
        }, 20000);
      } else {
        setTimeout(show, delay * 1000);
      }

      var backdrop = popup.querySelector('.newsletter-popup__backdrop');
      var closeBtn = popup.querySelector('.newsletter-popup__close');

      if (backdrop) backdrop.addEventListener('click', hide);
      if (closeBtn) closeBtn.addEventListener('click', hide);

      popup.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;

        var focusable = popup.querySelectorAll(focusableSelector);
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });

      function onEscape(e) {
        if (e.key === 'Escape' && popup.style.display === 'flex') {
          hide();
          document.removeEventListener('keydown', onEscape);
        }
      }

      document.addEventListener('keydown', onEscape);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-system-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var medias = document.querySelectorAll('.sistema-card__media[data-image-count]');
    if (!medias.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    medias.forEach(function (media) {
      var count = parseInt(media.dataset.imageCount, 10);
      if (!count || count < 2) return;
      var imgs = media.querySelectorAll('.sistema-card__img');
      if (imgs.length < 2) return;

      var index = 0;
      var timer = null;

      function show(i) {
        imgs.forEach(function (img, k) {
          img.classList.toggle('is-active', k === i);
        });
      }

      function start() {
        if (timer) return;
        if (reduce) {
          index = 1 % imgs.length;
          show(index);
          return;
        }
        index = (index + 1) % imgs.length;
        show(index);
        timer = window.setInterval(function () {
          index = (index + 1) % imgs.length;
          show(index);
        }, 1100);
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
        index = 0;
        show(0);
      }

      media.addEventListener('mouseenter', start);
      media.addEventListener('mouseleave', stop);
      media.addEventListener('focusin', start);
      media.addEventListener('focusout', stop);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var tabNav = document.querySelector('.product-tabs__nav');
    if (!tabNav) return;
    tabNav.addEventListener('click', function (e) {
      var tab = e.target.closest('.product-tabs__tab');
      if (!tab) return;
      var tabId = tab.dataset.tab;
      var container = tab.closest('.product-tabs');
      container.querySelectorAll('.product-tabs__tab').forEach(function (t) {
        t.classList.remove('product-tabs__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      container.querySelectorAll('.product-tabs__panel').forEach(function (p) {
        p.classList.remove('product-tabs__panel--active');
      });
      tab.classList.add('product-tabs__tab--active');
      tab.setAttribute('aria-selected', 'true');
      var panel = container.querySelector('[data-panel="' + tabId + '"]');
      if (panel) panel.classList.add('product-tabs__panel--active');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
